import { buildModelManager } from "../builder.js";
const DefaultShopifyProductVariantSelection = {
  __typename: true,
  id: true,
  barcode: true,
  compareAtPrice: true,
  createdAt: true,
  fulfillmentService: true,
  grams: true,
  inventoryManagement: true,
  inventoryPolicy: true,
  inventoryQuantity: true,
  inventoryQuantityAdjustment: true,
  oldInventoryQuantity: true,
  option1: true,
  option2: true,
  option3: true,
  position: true,
  presentmentPrices: true,
  price: true,
  productId: true,
  productImageId: true,
  requiresShipping: true,
  selectedOptions: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  sku: true,
  taxCode: true,
  taxable: true,
  title: true,
  updatedAt: true,
  weight: true,
  weightUnit: true
};
const modelApiIdentifier = "shopifyProductVariant";
const pluralModelApiIdentifier = "shopifyProductVariants";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyProductVariantSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "updateShopifyProductVariant",
    operationReturnType: "UpdateShopifyProductVariant",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyProductVariant: { required: false, type: "UpdateShopifyProductVariantInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyProductVariantSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShopifyProductVariants",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateShopifyProductVariantsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyProductVariantSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyProductVariantGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...["create", "bulkCreate", "delete", "bulkDelete"].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyProductVariant does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyProductVariantManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyProductVariantSelection,
  operations
);
export {
  DefaultShopifyProductVariantSelection,
  ShopifyProductVariantManager
};
//# sourceMappingURL=ShopifyProductVariant.js.map
